<div class="main">
    <div class="mainDiv"   [id]="randomId" [style.width]="width" [style.height]="height" [style.backgroundColor]="backgroundColor">
        <div class="imgDiv"  [style.width]="getWidth()" [style.height]="getHeight()" >

            <img class="upload-image" *ngIf="uploadedImageSrc || selectedImage" style="height: 98%; width: 100% ; border-top-left-radius: 4px; border-top-right-radius: 4px;"  [src]="uploadedImageSrc" alt="" >
        </div>
        <div class="bottom-btns" [style.width]="width">
            <div class="btn" (click)="onClick()">
                <i class="material-icons ">add</i>
            </div>
            <div class="btn" *ngIf="uploadedImageSrc || selectedImage" (click)="delete()"> <i class="material-icons">delete</i></div>
            <div class="btn" *ngIf="iconType" (click)="customFunction()"> <i class="material-icons">{{iconType}}</i></div>
        </div>
    </div>
   
    
    <input type="file" id="lsimageupload2" style="display:none" (change)="getImage()" accept="image/*" />
</div>